import { addEvent } from "../addEvent/addEvent";

export const mainMenu = class {
  mainContainer = false;
  activeSubmenu = false;
  haveSubmenuClass = "have-submenu";
  showSubmenuClass = "show-submenu";
  hideSubmenuClass = "hide-submenu";
  animationInTime = 300;
  animationOutTime = 300;
  closeTimer = false;
  closeTime = 1000;

  constructor(mainContainer) {
    if (!mainContainer) {
      return false;
    }

    this.mainContainer = mainContainer;
    this._start();
    return this;
  }

  _start = () => {
    const mainUlElement = this.mainContainer.getElementsByTagName("ul")[0];
    let mainLiElements = mainUlElement.querySelectorAll("li");

    mainLiElements.forEach((liElement) => {
      if (liElement.parentNode != mainUlElement) {
        return;
      }
      const submenu = liElement.getElementsByTagName("ul");
      if (submenu.length > 0) {
        liElement.classList.add(this.haveSubmenuClass);
        this._addOnHoverLink(liElement);
        this._addOutHover(liElement);
        this._addOnHover(liElement);
      } else {
        this._addOnHoverEmpty(liElement);
      }
    });

    this._clickOutSide();
  };

  _addOnHoverLink = (elm) => {
    addEvent(elm, "mouseover", (e) => {
      e.stopPropagation();
      e.preventDefault();

      this._showSubmenu(elm);
    });
  };
  
  _addOnHoverEmpty= (elm) => {
    addEvent(elm, "mouseover", (e) => {
      e.stopPropagation();
      e.preventDefault();

      this._hideSubmenu(this.activeSubmenu);
    });
  };

  _addOnHover = (elm) => {
    addEvent(elm, "mouseover", (e) => {
      clearTimeout(this.closeTimer);
    });
  };

  _addOutHover = (elm) => {
    addEvent(elm, "mouseout", (e) => {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        this._hideSubmenu(this.activeSubmenu);
      }, this.closeTime);
    });
  };

  _clickOutSide = () => {
    addEvent(document, "click", (e) => {
      const targetElement = e.target;
      if (targetElement !== this.activeSubmenu) {
        this._hideSubmenu(this.activeSubmenu);
      }
    });
  };

  _showSubmenu = (elm) => {
    if (!elm) {
      return;
    }
    this._hideSubmenu(this.activeSubmenu);

    this.activeSubmenu = elm;
    elm.classList.remove(this.hideSubmenuClass);
    elm.classList.add(this.showSubmenuClass);
  };

  _hideSubmenu = (elm) => {
    if (!elm) {
      return;
    }
    this.activeSubmenu = false;
    elm.classList.remove(this.showSubmenuClass);
    elm.classList.add(this.hideSubmenuClass);

    setTimeout(() => {
      elm.classList.remove(this.hideSubmenuClass);
    }, this.animationOutTime);
  };
};
